var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("FormEditor", {
        attrs: { viewModel: _vm.formEditor },
        on: { "save-form": _vm.handleFormEditorSave },
      }),
      _vm._v(" "),
      _c("FormDeleterDialog", {
        attrs: { viewModel: _vm.formDeleterDialog },
        on: { "delete-form": _vm.handleDeleteFormCommand },
      }),
      _vm._v(" "),
      _c("FormDependenciesDialog", {
        attrs: { viewModel: _vm.formDependenciesDialog },
      }),
      _vm._v(" "),
      _c("PortfolioNavigation", {
        attrs: { workspaceId: _vm.workspaceId, projectId: _vm.projectId },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "container",
          staticStyle: { "margin-top": "80px", "padding-top": "40px" },
        },
        [
          _c("div", { staticClass: "row" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-6 text-right" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-success",
                  staticStyle: { padding: "0.7em 2em" },
                  on: { click: _vm.showFormCreator },
                },
                [_vm._v("\n                    Create form\n                ")]
              ),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("hr", {
        staticStyle: { "border-color": "#bbb", margin: "20px 0 60px" },
      }),
      _vm._v(" "),
      _vm.rm
        ? _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-lg-4 offset-lg-8" }, [
                _c("div", { staticClass: "input-group input-group-lg" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.SearchPhrase,
                        expression: "SearchPhrase",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "search", placeholder: "Search" },
                    domProps: { value: _vm.SearchPhrase },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.SearchPhrase = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm._m(1),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "table",
              {
                staticClass:
                  "table table-bordered table-hover table-browser mt-3",
              },
              [
                _c("thead", [
                  _c("tr", [
                    _c(
                      "th",
                      {
                        staticClass: "sortable",
                        class: { selected: _vm.OrderBy === "name" },
                        on: {
                          click: function ($event) {
                            return _vm.orderByName()
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "text-uppercase font-weight-normal" },
                          [_vm._v("Name")]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "fa-stack" }, [
                          _c("i", {
                            staticClass: "fa fa-sort-asc fa-stack-1x",
                            class: {
                              selected:
                                _vm.OrderBy === "name" &&
                                _vm.OrderByDescending === false,
                            },
                          }),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "fa fa-sort-desc fa-stack-1x",
                            class: {
                              selected:
                                _vm.OrderBy === "name" &&
                                _vm.OrderByDescending === true,
                            },
                          }),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "sortable text-center",
                        class: { selected: _vm.OrderBy === "modified" },
                        staticStyle: { width: "180px" },
                        on: {
                          click: function ($event) {
                            return _vm.orderByModified()
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "text-uppercase font-weight-normal" },
                          [_vm._v("Updated on")]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "fa-stack" }, [
                          _c("i", {
                            staticClass: "fa fa-sort-asc fa-stack-1x",
                            class: {
                              selected:
                                _vm.OrderBy === "modified" &&
                                _vm.OrderByDescending === false,
                            },
                          }),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "fa fa-sort-desc fa-stack-1x",
                            class: {
                              selected:
                                _vm.OrderBy === "modified" &&
                                _vm.OrderByDescending === true,
                            },
                          }),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "sortable text-center",
                        class: { selected: _vm.OrderBy === "created" },
                        staticStyle: { width: "180px" },
                        on: {
                          click: function ($event) {
                            return _vm.orderByCreated()
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "text-uppercase font-weight-normal" },
                          [_vm._v("Created on")]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "fa-stack" }, [
                          _c("i", {
                            staticClass: "fa fa-sort-asc fa-stack-1x",
                            class: {
                              selected:
                                _vm.OrderBy === "created" &&
                                _vm.OrderByDescending === false,
                            },
                          }),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "fa fa-sort-desc fa-stack-1x",
                            class: {
                              selected:
                                _vm.OrderBy === "created" &&
                                _vm.OrderByDescending === true,
                            },
                          }),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("th", { staticStyle: { width: "90px" } }),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.formsView, function (f) {
                    return _c("tr", { key: f.Id }, [
                      _c("td", [
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "sanitizedHref",
                                rawName: "v-sanitizedHref",
                                value: `/#/pp/edit-form/${_vm.workspaceId}/${_vm.projectId}/${f.Id}`,
                                expression:
                                  "`/#/pp/edit-form/${workspaceId}/${projectId}/${f.Id}`",
                              },
                            ],
                            staticClass: "text-dark",
                          },
                          [_vm._v(_vm._s(f.Name))]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-center" }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.getFormattedDateStr(f.Modified))),
                        ]),
                        _c("br"),
                        _vm._v(" "),
                        _c("small", [
                          _vm._v(_vm._s(_vm.getFormattedTimeStr(f.Modified))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-center" }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.getFormattedDateStr(f.Created))),
                        ]),
                        _c("br"),
                        _vm._v(" "),
                        _c("small", [
                          _vm._v(_vm._s(_vm.getFormattedTimeStr(f.Created))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "dropdown" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-outline-secondary dropdown-toggle",
                              attrs: {
                                type: "button",
                                "data-toggle": "dropdown",
                                "aria-haspopup": "true",
                                "aria-expanded": "false",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                Actions\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "dropdown-menu dropdown-menu-right",
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.showFormEditor(f)
                                    },
                                  },
                                },
                                [_vm._v("Rename")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  directives: [
                                    {
                                      name: "sanitizedHref",
                                      rawName: "v-sanitizedHref",
                                      value: `/#/pp/edit-form/${_vm.workspaceId}/${_vm.projectId}/${f.Id}`,
                                      expression:
                                        "`/#/pp/edit-form/${workspaceId}/${projectId}/${f.Id}`",
                                    },
                                  ],
                                  staticClass: "dropdown-item",
                                },
                                [_vm._v("Edit")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.showFormCloner(f)
                                    },
                                  },
                                },
                                [_vm._v("Clone")]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "dropdown-divider" }),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.showFormDependenciesViewer(f)
                                    },
                                  },
                                },
                                [_vm._v("View dependencies")]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "dropdown-divider" }),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.showFormDeleter(f)
                                    },
                                  },
                                },
                                [_vm._v("Delete")]
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ])
                  }),
                  0
                ),
              ]
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-lg-6" }, [
      _c(
        "h1",
        {
          staticStyle: {
            "font-size": "2em",
            "font-weight": "300",
            color: "#33475b",
            margin: "0",
          },
        },
        [_vm._v("Forms")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "input-group-append" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", {
          staticClass: "fa-solid fa-magnifying-glass",
          attrs: { "aria-hidden": "true" },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }